export const TREAT_AND_RELEASE_LABEL = 'Treat and Release';
export const BASIC_RED_CROSS_ASSIST_LABEL = 'Basic / Red Cross Assist';
export const TRANSPORTATION_TO_HOSPITAL_LABEL = 'Transportation to Hospital';

export const SERVICE_PROVIDED_ENUM = [TREAT_AND_RELEASE_LABEL, 
    TRANSPORTATION_TO_HOSPITAL_LABEL, BASIC_RED_CROSS_ASSIST_LABEL, 
    'Left AMA', 'POV'] as const;

export const LEVEL_OF_TREATMENT_ENUM = ['ALS', 'BLS'] as const;